import { PromptRunner } from "./promptRunner";

/**
 * Shared PromptRunner socket singleton.
 *
 * One socket per authenticated user serves every run type (playground prompt
 * runs and eval runs). Both the prompts and eval-runner RTK Query slices
 * subscribe to it; each patches only its own cache (jobs are matched by id), so
 * the streams coexist safely on a single connection.
 */
export const promptRunner = new PromptRunner();
